import api from '../api'
import Validation from '../validation'
import PrivilegeMixin from './PrivilegeMixin'

export default {
  name: 'CommonMixin',
  mixins: [PrivilegeMixin],
  // props: {
  // },
  data () {
    return {
      validator: Validation.createValidator(),
      api: api
    }
  },
  // watch: {
  // },
  methods: {
    gotoOverviewWithFilter (name, filter) {
      this.$store.commit({type: 'setFilter', name: name, value: filter})
      this.$router.push({name: name})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CommonMixin.js